module.exports = __webpack_public_path__ + "static/media/thumbnail.2b4bcbec.jpg";